import { CoveragePlanStatus } from '@cms-max/medicare-api-sdk'
import { usePlansQuery } from 'queries/plans'
import { useMemo } from 'react'

// Helper hook to extract rx drug coverage from current plans
export function useDrugPlanInfo (
  status: CoveragePlanStatus = CoveragePlanStatus.Current
) {
  const { isLoading, data: plansData } = usePlansQuery()

  const data = useMemo(() => {
    if (!plansData) return undefined

    const rxPlan = plansData.plans.find((p) => p.status === status && p.rxCard)

    return rxPlan?.rxCard
  }, [plansData, status])

  return {
    isLoading,
    data
  }
}
